import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Row, Col} from 'react-bootstrap'
import OrdersList from './complete-orders-list'
import SimpleSearchComponent from '../common/search/simple-search-component'
import {getCompleteOrders} from '../../actions/orders'

class CompleteOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderNumber: '',
      pageNumber: 1
    };
  }

  componentWillMount() {
    this.props.dispatch(getCompleteOrders());
  }

  handleInputChange = (e) => {
    this.setState({orderNumber: e.target.value});
  };

  handleSearch = () => {
    const {orderNumber, pageNumber} = this.state;
    this.props.dispatch(getCompleteOrders(orderNumber, pageNumber));
  };

  handleClear = () => {
    this.setState({
      orderNumber: '',
      pageNumber: 1,}
      , this.handleSearch);
  };

  handlePageChange = (page, size) => {
    this.setState({pageNumber:  page}, this.handleSearch);
  };

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <SimpleSearchComponent searchValue={this.state.orderNumber}
                                   onInputChange={this.handleInputChange}
                                   onSearch={this.handleSearch}
                                   onClear={this.handleClear}
                                   placeholder="search by Order Number (exact match)"/>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.props.fetched &&
             <OrdersList
               orders={this.props.orders}
               fetching={this.props.fetching}
               fetched={this.props.fetched}
               pagination={this.props.pagination}
               onPageChange={this.handlePageChange}
               currentPage={this.state.pageNumber}
            />}
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orders:   state.orders.completeList,
    pagination:   state.orders.completeListPaging,
    fetching: state.orders.complete_fetching,
    fetched:  state.orders.complete_fetched
  };
};

export default connect(mapStateToProps)(CompleteOrders);


// WEBPACK FOOTER //
// ./src/components/my-orders/complete-orders.jsx